// extracted by mini-css-extract-plugin
module.exports = {"item":"AvatarPicker_item__2o9q1"};